import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getUserNameFromReducer } from "Store/reducers/Auth/AuthSlice";
import BusinessInfoForm from "./BusinessInfoForm";
import QRCode from "./QRCode";
import "./ReviewStyle.css";

const ReviewGenerator = () => {
  const userName = useSelector(getUserNameFromReducer);
  const [qrData, setQrData] = useState({
    showQRCode: false,
    businessName: "",
  });

  const handleDataChange = (data) => {
    setQrData(data);
  };

  return (
    <div className="min-h-screen bg-gray-100 px-2 py-6 md:px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-lg lg:text-2xl font-bold text-center md:mb-5 mb-14">Edit Google Review Business Info</h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
          <BusinessInfoForm
            userName={userName}
            onDataChange={handleDataChange}
          />
          
          <QRCode
            userName={userName}
            businessName={qrData.businessName}
            showQRCode={qrData.showQRCode}
          />
        </div>
      </div>
    </div>
  );
};

export default ReviewGenerator;
